import { z } from 'zod';

import { TIPOS_DE_ATOR } from '../types/negociacaoMarcoTypes';

const atorSchema = z.object({
  tipo: z.enum(TIPOS_DE_ATOR),
  nome: z.string().nullable(),
});

const linkSchema = z.object({
  url: z.string(),
  rotulo: z.string(),
});

const marcoSchema = z.object({
  id: z.string(),
  tipo: z.string(),
  titulo: z.string(),
  descricao: z.string(),
  ator: atorSchema,
  dataHora: z.string(),
  link: linkSchema.nullable(),
});

export const paginaMarcosSchema = z.object({
  items: z.array(marcoSchema),
  nextCursor: z.string().nullable(),
  hasMore: z.boolean(),
});
